module.exports = __webpack_public_path__ + "static/Go-d4ccb86cff7f91622a419780d9a3e305.png";